import React, { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import IMG from "../home/Car_1.png";
import AOS from "aos";
import "aos/dist/aos.css";
import Typewriter from "typewriter-effect";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";

const Hero = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const headingTexts = [
    "Twin Star Industries",
    "Best Partner for Manufacturing",
    "Strength Behind Every Automobile.",
  ];

  return (
    <section className="relative w-full min-h-screen flex items-center bg-black overflow-hidden">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-85"
      >
        <source
          src="https://res.cloudinary.com/dzp9ogv39/video/upload/v1756008913/watermarked-36cfe182-5d18-47fc-a608-26df9d235176_aloxus.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      {/* Navbar Over Hero */}
      <div className="fixed top-0 bg-gray-400/55 left-0 w-full z-20">
        <Navbar />
      </div>

      {/* Content */}
      <div className="relative z-10 mt-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10 sm:py-14 lg:py-16 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        {/* Left Content */}
        <div className="space-y-5 sm:space-y-6 text-center lg:text-left">
          {/* Blue Badge */}
          <div
            className="inline-flex items-center space-x-2 sm:space-x-3 bg-blue-100 text-white px-[6px] pr-[12px] sm:pr-[16px] py-[4px] sm:py-[6px] rounded-full text-xs sm:text-sm font-medium"
            data-aos="fade-up"
          >
            <span className="bg-blue-900 text-white text-xs sm:text-sm md:text-base px-2 sm:px-3 py-[4px] sm:py-1 rounded-full font-bold">
              45+ Years
            </span>
            <span className="text-[12px] sm:text-[14px] text-black font-medium">
              Of Precision Fastening Solutions
            </span>
          </div>

          <div className="max-md:h-40 h-80">
            {/* Heading with infinite Typewriter */}
            <h1
              className="text-[32px] sm:text-[40px] md:text-[55px] lg:text-[70px] font-semibold leading-tight text-white"
              data-aos="fade-up"
            >
              <Typewriter
                options={{
                  strings: headingTexts,
                  autoStart: true,
                  loop: true,
                  delay: 50,
                  deleteSpeed: 30,
                  pauseFor: 2000,
                }}
              />
            </h1>

            {/* Subheading */}
            <p
              className="text-base sm:text-lg font-normal text-gray-300 max-w-xl mx-auto lg:mx-0"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Since 1981, delivering quality fasteners and automobile components
              across industries with innovation and trust.
            </p>
          </div>

          {/* Button */}
          <button
            className="relative overflow-hidden inline-flex items-center gap-2 px-6 py-3 sm:py-4 rounded-full border border-black text-white hover:bg-blue-900 hover:text-white font-medium group transition-colors duration-300"
            data-aos-delay="300"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              navigate("/about");
            }}
          >
            <span className="relative z-10 flex items-center gap-2">
              <span className="relative block overflow-hidden h-6">
                <span className="block transition-transform duration-300 transform group-hover:-translate-y-full">
                  Know More About Us
                </span>
                <span className="absolute top-full left-0 w-full block text-white transition-transform duration-300 transform group-hover:-translate-y-full">
                  Know More About Us
                </span>
              </span>
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </span>
          </button>
        </div>

        {/* Right Image */}
        <div
          className="relative w-full aspect-w-16 aspect-h-9 sm:aspect-h-7"
          data-aos="fade-left"
        >
          <img
            src={IMG}
            alt="Twin Star Hero"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
      </div>

      {/* Cursor Color */}
      <style jsx global>{`
        .Typewriter__cursor {
          color: #1e3a8a !important;
          font-weight: 300;
        }
      `}</style>
    </section>
  );
};

export default Hero;
